module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Pride-And-Prejudice-landscape.fa7f0e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Pride-And-Prejudice-landscape.jpg
// module id = 0rOP
// module chunks = 0